export const paymentInitialState = {
  payment: {
    data: {},
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false
    },
    currentCountry: {
      label: 'Выберете страну',
      value: null
    },
    currentTypePayment: {
      label: 'Выберете тип перевода',
      value: null
    },
    optionCard: [],
    selectedOptionCard: {
      label: 'Банк',
      value: null
    },
    selectors: {},
    filters: {}
  }
};
